import { render, staticRenderFns } from "./report-general-ingress-component.vue?vue&type=template&id=3a57edbc&scoped=true&"
import script from "./report-general-ingress-component.vue?vue&type=script&lang=js&"
export * from "./report-general-ingress-component.vue?vue&type=script&lang=js&"
import style0 from "./report-general-ingress-component.vue?vue&type=style&index=0&id=3a57edbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57edbc",
  null
  
)

export default component.exports